import apiClient from './apiClient';

class AIAnalyticsService {
  async getMarketInsights(properties) {
    try {
      const response = await apiClient.post('/ai/market-insights', {
        properties: properties.slice(0, 100) // Limit for API efficiency
      });
      return response.data;
    } catch (error) {
      console.error('Error getting market insights:', error);
      throw error;
    }
  }

  async getPropertyRecommendations(userPreferences, properties) {
    try {
      const response = await apiClient.post('/ai/property-recommendations', {
        preferences: userPreferences,
        properties: properties.slice(0, 50)
      });
      return response.data;
    } catch (error) {
      console.error('Error getting property recommendations:', error);
      throw error;
    }
  }

  async getInvestmentAnalysis(property) {
    try {
      const response = await apiClient.post('/ai/investment-analysis', {
        property
      });
      return response.data;
    } catch (error) {
      console.error('Error getting investment analysis:', error);
      throw error;
    }
  }

  async getRiskAssessment(properties) {
    try {
      const response = await apiClient.post('/ai/risk-assessment', {
        properties: properties.slice(0, 50)
      });
      return response.data;
    } catch (error) {
      console.error('Error getting risk assessment:', error);
      throw error;
    }
  }

  async getMarketTrendPrediction(historicalData) {
    try {
      const response = await apiClient.post('/ai/market-prediction', {
        data: historicalData
      });
      return response.data;
    } catch (error) {
      console.error('Error getting market trend prediction:', error);
      throw error;
    }
  }

  async getPortfolioOptimization(currentPortfolio, availableProperties) {
    try {
      const response = await apiClient.post('/ai/portfolio-optimization', {
        currentPortfolio,
        availableProperties: availableProperties.slice(0, 30)
      });
      return response.data;
    } catch (error) {
      console.error('Error getting portfolio optimization:', error);
      throw error;
    }
  }
}

export default new AIAnalyticsService(); 